var _g, _path, _g2, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEuroLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 76,
    viewBox: "0 0 96 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_107_2284)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66.6682,
    cy: 44.6683,
    r: 24,
    transform: "rotate(7.4756 66.6682 44.6683)",
    fill: "#8CEEEE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.1697 53.3653C69.7284 53.4306 70.2764 53.4527 70.8137 53.4316C71.351 53.4106 71.8674 53.3451 72.3626 53.2352L72.4498 56.3917C71.8328 56.4664 71.1935 56.507 70.532 56.5135C69.8705 56.5201 69.2036 56.4841 68.531 56.4054C67.2585 56.2566 66.1111 55.9337 65.089 55.4367C64.0773 54.9408 63.2263 54.2802 62.5363 53.4549C61.8474 52.6193 61.3498 51.6277 61.0435 50.4802C60.7487 49.3235 60.6872 48.0106 60.859 46.5415L61.4741 41.2805C61.6507 39.7699 62.0171 38.4756 62.5731 37.3974C63.1407 36.3102 63.8624 35.4297 64.7383 34.756C65.6244 34.0835 66.6279 33.6188 67.7487 33.3618C68.8798 33.106 70.1023 33.0549 71.4163 33.2085C72.0578 33.2835 72.6731 33.4027 73.2623 33.566C73.863 33.7201 74.4601 33.9053 75.0536 34.1215L74.2389 37.1883C73.8018 36.9798 73.3197 36.7976 72.7925 36.6416C72.2758 36.4868 71.7484 36.3779 71.2104 36.315C70.4137 36.2219 69.6808 36.2568 69.0115 36.4197C68.3525 36.5839 67.7722 36.8831 67.2705 37.3174C66.7699 37.7413 66.3565 38.317 66.0303 39.0444C65.7143 39.7731 65.4953 40.6599 65.3731 41.7049L64.7543 46.9969C64.6334 48.0316 64.6489 48.9301 64.801 49.6925C64.9646 50.4457 65.2417 51.0812 65.6321 51.5988C66.0238 52.106 66.5173 52.5046 67.1127 52.7944C67.7184 53.0855 68.4041 53.2758 69.1697 53.3653ZM71.0088 41.6716L70.7603 43.7978L58.6242 42.3788L58.8728 40.2527L71.0088 41.6716ZM70.5226 45.8308L70.274 47.9569L58.1379 46.538L58.3865 44.4118L70.5226 45.8308Z",
    fill: "#262626"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_107_2284)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.7611,
    cy: 30.7611,
    r: 24,
    transform: "rotate(-20 30.7611 30.7611)",
    fill: "#FDE759"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.993 37.3231C37.5188 37.1233 38.0152 36.8901 38.4822 36.6235C38.9492 36.3568 39.377 36.0605 39.7658 35.7345L41.2994 38.4948C40.7864 38.8457 40.238 39.1767 39.6542 39.4877C39.0703 39.7987 38.4619 40.0745 37.829 40.315C36.6313 40.7701 35.4644 41.0129 34.3282 41.0435C33.2018 41.0704 32.1421 40.8769 31.1491 40.4631C30.1524 40.0395 29.2534 39.3893 28.4522 38.5126C27.6571 37.6224 26.9968 36.486 26.4714 35.1033L24.5898 30.1518C24.0496 28.7302 23.7774 27.4128 23.7734 26.1997C23.7753 24.9732 24.0094 23.8591 24.4756 22.8573C24.9516 21.8518 25.6274 20.9765 26.5032 20.2314C27.3887 19.4826 28.4498 18.8733 29.6864 18.4034C30.2902 18.1739 30.891 17.9958 31.4891 17.8688C32.0932 17.7284 32.7084 17.6172 33.3347 17.5352L34.0268 20.6319C33.5428 20.6487 33.031 20.7094 32.4914 20.8142C31.9615 20.9153 31.4433 21.062 30.937 21.2544C30.1872 21.5394 29.553 21.9085 29.0344 22.3619C28.5256 22.8115 28.1487 23.3448 27.9039 23.9615C27.6554 24.5685 27.5543 25.27 27.6004 26.066C27.6563 26.8582 27.8711 27.746 28.2448 28.7295L30.1375 33.7101C30.5075 34.6839 30.9358 35.4739 31.4225 36.0801C31.9152 36.6729 32.4542 37.1089 33.0394 37.3879C33.6209 37.6573 34.2426 37.7832 34.9046 37.7656C35.5763 37.7444 36.2724 37.5969 36.993 37.3231ZM33.2296 26.0998L33.99 28.1009L22.5681 32.4412L21.8077 30.4402L33.2296 26.0998ZM34.717 30.0142L35.4774 32.0153L24.0555 36.3556L23.2952 34.3546L34.717 30.0142Z",
    fill: "#262626"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_107_2284",
    x: 34.7497,
    y: 14.7498,
    width: 63.837,
    height: 63.837,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_107_2284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_107_2284",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_107_2284",
    x: -5,
    y: -2.99997,
    width: 71.5222,
    height: 71.5222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_107_2284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_107_2284",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroLeft);
export default __webpack_public_path__ + "static/media/euro_left.2d766e3dae118765f110389654f6e4d9.svg";
export { ForwardRef as ReactComponent };